
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { ButtonToggler } from "@/utilities/ButtonToggler";
    import { required, email } from "vuelidate/lib/validators";
    import { Utils } from "@/utilities/Utils";
    import { Validations } from "vuelidate-property-decorators";

    @Component({
        components: { 
            ApiButton
        }
    })
    export default class ItineraryReportSendModal extends Vue {

        //
        // -- properties
        //

        bookingID: number = 0;
        email: string = "";

        guid: string = Utils.newGuid();

        //
        // -- methods
        //

        show(bookingID: number) {
            this.email = "";
            this.bookingID = bookingID;
            this.loadContractorEmail();
        }

        async loadContractorEmail() {
            const response = await ApiClient.get(`/Api/Contractor/ContractorEmail?bookingID=${this.bookingID}`);
            this.email = response;
            this.$bvModal.show("itineraryReportSendModal");
        }

        cancel() {
            this.bookingID = 0;
            this.email = "";
            this.$bvModal.hide("itineraryReportSendModal");
        }

        async sendItinerary(event: Event) {
            const button = ButtonToggler.getButton(event);
            ButtonToggler.disableButton(button);

            if (!await this.isValid()) {
                toastr.info("Please fix the highlighted errors", "Validation errors");
                 ButtonToggler.enableButton(button);
                 return;
            }

            ButtonToggler.enableButton(button); // if we don't re-enable now, css is wrong when we try and re-enable later

            const postData = {bookingID: this.bookingID, email: this.email};
            await ApiClient.post("/Api/Report/EmailBookingItinerary", postData, event);
            toastr.success("Booking Itinerary Sent");
            this.$bvModal.hide("hotelModal");
            
        }

        @Validations()
        validations() {
            const validations = {
                /* eslint-disable */
                email: {} as any
            };
            validations.email = { required, email };
            return validations; 
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private async isValid(): Promise<boolean> {
            this.$v.$reset();
            this.$v.$touch();
            await this.waitForValidation();
            return Promise.resolve(!this.$v.$error);
        }

        // from https://github.com/vuelidate/vuelidate/issues/179
        private waitForValidation() {
            return new Promise<void>(resolve => {
                if (this.$v.$error || !this.$v.$pending) {
                    return resolve();
                }
                const poll = setInterval(() => {
                    if (!this.$v.$pending) {
                        clearInterval(poll)
                        resolve()
                    }
                }, 200);
            })
        }
    }

